<div class="application-form">
  <ng-container *ngFor="let form of applicationForms">
    <a [href]="form.url" [ngClass]="'application-form__url application-form__url--' + company | lowercase" target="_blank" download>{{ form.name }}</a>
  </ng-container>
</div>
